export interface Breadcrumb {
  name: string;
  href: string;
}

export enum DeviceType {
  DESKTOP = 'desktop',
  MOBILE = 'mobile',
}

export type Entries<T extends object> = {
  [K in keyof T]-?: [K, T[K]];
}[keyof T][];
